import { utilsService } from './services/utils.service';

// 主链
const baseUrl = (window.location.href.match(/^http[^#?]+\//i) || [])[0] || '';

const HOST = (() => {
  let host = 'https://test.thefront.com.cn/RRBoxGame';
  if (/(localhost|10.0.0)/.test(baseUrl)) host = 'https://test.thefront.com.cn/RRBoxGame';
  if (/(event)/.test(baseUrl)) host = 'https://rolls-royce-kryptos-challenge.fnws.top';
  return host;
})();

const wxJssdk = (() => {
  let jssdkHost = 'https://w1.thefront.com.cn/weixports/rolls_royce/getwxapi.php';
  // if (/fnws.top/i.test(baseUrl)) jssdkHost = 'https://api.fnws.top/wxapi/ftcontent';
  return jssdkHost;
})();

const wxApi = (() => {
  let url = 'https://open.weixin.qq.com/connect/oauth2/authorize';
  // if (/fnws.top/i.test(baseUrl)) url = 'https://api.fnws.top/wxapi/ftcards/getwxapi.php';
  return url;
})();

// 图片-视频接口
const FFmpegHost = (() => {
  let url = 'https://fc.fnws.top/FFmpeg';
  // if (/(localhost|10.0.0|192.168)/.test(baseUrl)) url = 'http://localhost:9999';
  return url;
})();

// 图片过滤接口
const imgHost = (() => {
  let url = 'https://bmw-ed.fnws.top';
  // if (/(localhost|10.0.0|192.168)/.test(baseUrl)) url = 'http://localhost:9999';
  return url;
})();

// vod host
const vodHost = (() => {
  let url = 'https://fc.fnws.top/aliyun';
  // if (/(localhost|10.0.0|192.168)/.test(baseUrl)) url = 'http://localhost:9002';
  return url;
})();

export const APP_CONFIG = {
  appId: 'wx3d09c0c7879c5a45', // test.fnws.top
  privateKey: '64aVaMI6aRce6h2I',

  /** 分享链接 */
  shareLink: baseUrl,
  /** 网站根路径 */
  baseUrl,
  /** 微信分享接口地址 */
  wxJssdk,
  /** 微信公众号接口地址 */
  wxApi,
  /** 网站后端接口 */
  ep: {
    /** 微信授权跳转 */
    getOpenIdUrl: `${HOST}/wechat/authorize`,
    /** 表单提交 */
    postForm: `${HOST}/checkpoint/info`,
    /** 表单提交 */
    postTestDrive: `${HOST}/drive/sub_test_drive_info`,
    /** 获取用户信息 */
    getUserInfo: `${HOST}/checkpoint/getinfo`,
    /** 提交游戏数据 */
    postGameInfo: `${HOST}/checkpoint/clearance`,
    /** 参与抽奖 */
    lottery: `${HOST}/checkpoint/push_prize_pool`,
    /** 提交领奖信息 */
    postPrizeInfo: `${HOST}/lucky/address`,
    /** 领取红包封面 */
    getPacket: `${HOST}/checkpoint/get_red_packet`,
    /** 获取中奖名单 */
    luckylist: `${HOST}/checkpoint/luckylist`,
  },
  fc: {
    toVideo: `${FFmpegHost}/toVideo`,
    videoClips: `${FFmpegHost}/videoClips`,
    vod: `${vodHost}/vod`,
    download: `${vodHost}/download`,
    save: `${imgHost}/client/pic/save`,
  },

  siteName: 'wk',
  version: '1.1.4',
};
